import React, { useState } from 'react';

import SearchBox, { SearchParams } from './SearchBox';

interface SearchContainerProps {
  withBg?: boolean;
  withBudget?: boolean;
  budgetList?: Record<string, number>;
  onSearch: ({
    originalWhere,
    whereType,
    whereValue,
    moveIn,
    contractPeriod,
    roomTypes,
    minBudget,
    maxBudget,
  }: SearchParams) => void;
}

export const roomTypeList = ['Studio', 'Sharehouse', 'Officetel', 'Others'];

export type searchType = 'WHERE' | 'MOVEIN' | 'PERIOD' | 'GUEST' | 'ROOM' | 'BUDGET' | null;

const SearchContainer = ({ withBg, withBudget, budgetList, onSearch }: SearchContainerProps) => {
  const [active, setActive] = useState<searchType>(null);

  return (
    <>
      {withBg ? (
        <div className="z-10 w-full bg-white">
          <SearchBox
            withBg={withBg}
            withBudget={withBudget}
            active={active}
            setActive={setActive}
            onSearch={onSearch}
            budgetList={budgetList}
          />
        </div>
      ) : (
        <>
          {active && <div className="fixed inset-0 z-20 bg-black/50" onClick={() => setActive(null)} />}
          <SearchBox
            withBg={withBg}
            withBudget={withBudget}
            active={active}
            setActive={setActive}
            onSearch={onSearch}
            budgetList={budgetList}
          />
        </>
      )}
    </>
  );
};

export default SearchContainer;
